export default {"src":"/_next/static/media/vision.07b0650b.svg","height":120,"width":121};